import React, { useState } from "react";
import { FaBars, FaTimes } from "react-icons/fa";
import { NavLink, useNavigate } from "react-router-dom";
import "./Navbarmodule.css";

const Navbar = () => {
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const navigate = useNavigate();

  const closeDrawer = () => setIsDrawerOpen(false);

  const goHome = () => {
    closeDrawer();
    navigate("/");
  };

  const goCounselling = () => {
    closeDrawer();
    navigate("/counselling");
  };

  return (
    <nav className="NavMain">
      <button
        type="button"
        className="companyname"
        onClick={goHome}
        aria-label="StudyAIPlacement Home"
      >
        <img
          src="/sneh-logo.png"
          alt="StudyAIPlacement"
          className="brand-logo-img"
        />
      </button>

      <button
        type="button"
        className="drawer-icon"
        onClick={() => setIsDrawerOpen((open) => !open)}
        aria-label="Toggle navigation"
      >
        {isDrawerOpen ? <FaTimes /> : <FaBars />}
      </button>

      <div className={`buttons ${isDrawerOpen ? "drawer-open" : ""}`}>
        <NavLink to="/" end className="NavButton" onClick={closeDrawer}>
          Home
        </NavLink>

        <NavLink
          to="/success-stories-newsletter"
          className="NavButton"
          onClick={closeDrawer}
        >
          Success Stories
        </NavLink>

        <NavLink
          to="/study-roadmap"
          className="NavButton roadmap-nav"
          onClick={closeDrawer}
        >
          Study Roadmap
        </NavLink>

        <NavLink
          to="/fees-benefits"
          className="NavButton fees-benefits-nav"
          onClick={closeDrawer}
        >
          Fees & Career Blueprint
        </NavLink>

        <NavLink
          to="/admission"
          className="NavButton admission-nav"
          onClick={closeDrawer}
        >
          Apply for Admission
        </NavLink>

        <NavLink
          to="/global-talent"
          className="NavButton global-talent-nav"
          onClick={closeDrawer}
        >
          Experienced Professionals
        </NavLink>

        <NavLink
          to="/industry-experience"
          className="NavButton industry-experience-nav"
          onClick={closeDrawer}
        >
          Skilled, No Experience
        </NavLink>

        <button
          type="button"
          className="NavButton counselling-nav"
          onClick={goCounselling}
        >
          Counselling
        </button>

        <NavLink
          to="/student-login"
          className="NavButton student-login-nav"
          onClick={closeDrawer}
        >
          Student Login
        </NavLink>
      </div>
    </nav>
  );
};

export default Navbar;
